/* eslint-disable unused-imports/no-unused-vars */
import { SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import { MiViewScreen } from 'basics/enums/miview.enums';

const useMiViewScreenSelector = (
  defaultValue: string,
  setNewScreen: Function,
) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [screens, setScreens] = useState(Object.values(MiViewScreen));

  const handleChange = (event: SelectChangeEvent) => {
    if (event.target.value !== '') {
      setNewScreen(event.target.value as string);
      setSelectedValue(event.target.value as string);
    }
  };

  return {
    handleChange,
    selectedValue,
    screens,
  };
};

export default useMiViewScreenSelector;
